const renderSwapComponent = (matchId, matchComponent, defaultComponent) => id =>
  id === matchId ? matchComponent : defaultComponent;

export default renderSwapComponent;
